import { Stack } from "@mui/material";
import DollarRatesCard from "features/market/components/DollarRatesCard";
import MarketQuotesCard from "features/market/components/MarketQuotesCard";
import PanelSectionLink from "app/components/layout/panel/PanelSectionLink";
import { useTranslation } from "shared/hooks/useTranslation";

import { useUserSession } from "shared/contexts/UserContext";

export default function QuotesPanelPane() {
    const { t, getPathWithLanguage } = useTranslation();
    const { profile } = useUserSession();
    const cotizacionesPath = profile?.username
        ? getPathWithLanguage(`${profile.username}/cotizaciones`)
        : "#";

    return (
        <Stack spacing={2}>
            <DollarRatesCard density="panel" viewFullHistoryHref={cotizacionesPath} />
            <MarketQuotesCard density="panel" viewFullMarketHref={cotizacionesPath} />
            <PanelSectionLink to={cotizacionesPath} label={t("secondaryPanel.viewMarket")} />
        </Stack>
    );
}
